var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "rub",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 440",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.522,242.428c63.913,0,115.91-54.382,115.91-121.227C348.432,54.37,296.435,0,232.522,0H120.568v282.428h-29v30h29V440 h30V312.428h101.955v-30H150.568v-40H232.522z M150.568,30h81.955c47.371,0,85.91,40.912,85.91,91.201 c0,50.303-38.539,91.227-85.91,91.227h-81.955V30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRub);
export default __webpack_public_path__ + "static/media/rub.f77774a1d4f7be37f696a6a60bc8a78f.svg";
export { ForwardRef as ReactComponent };